module.exports = __webpack_public_path__ + "static/media/egratacos2.17a52164.jpg";